// Unfortunately, `scrollIntoView` seems buggy for some reason; it is not honouring our scrollPaddingTop style in some cases

export const scrollToHonouringScrollPaddingTop = (target: HTMLElement) => {
  const scrollPaddingTop =
    parseInt(getComputedStyle(target).scrollPaddingTop, 10) || 0;

  window.scrollTo({
    behavior: 'smooth',
    top: target.getBoundingClientRect().top + window.scrollY - scrollPaddingTop,
  });
};
